<template>
  <Modal @close="$emit('close')">
    <FormValidation
      class="text"
      @submit="$emit('submit')"
      @update:isDirty="$emit('update:isDirty', $event)">
      <slot />
    </FormValidation>
  </Modal>
</template>

<script>
export default {
  props: {
    isDirty: Boolean,
  },
}
</script>
